import jwtDecode from "jwt-decode";

export const user = state => state.user;
export const participant = state => state.participant;
export const token = state => state.token && jwtDecode(state.token);
export const refreshToken = state => state.refreshToken;
export const awsToken = state => state.awsToken;
export const showLoader = state => state.showLoader;
export const participantAWSToken = state => state.participantAWSToken;
export const participantRegistration = state => state.participantRegistration;
export const participantStudyStartStatus = state => state.studyStartStatus;
export const isUserSessionExpired = state => state.sessionExpired;
